module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "copyright-information"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "180px"
    }
  }, [_c('p', [_c('strong', [_vm._v("Other novels by Colin Cossor:")])]), _c('br'), _vm._v(" "), _c('p', [_c('em', [_vm._v("On Wings of Song")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Wild Justice")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Either Side the River")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Over the Hill")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Struggle")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("All Their Pride")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("The Woman at Checkout Nine")])]), _vm._v(" "), _c('p', [_c('em', [_vm._v("Rita")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdde7154","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 72
// module chunks = 0